<script lang="ts">
  import { onMount } from "svelte";
  import GrappleAuditLogTable from "../components/auditLogTable.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";
  import { injectAuditLogCss } from "../lib/gruimModuleTheme";

  let elDashboard: HTMLDivElement;

  const mountGrappleAuditLogDashboard = async (): Promise<void> => {
    try {
      const { default: GrappleAuditLogDashboard } = await import("App/auditLogDashboard");

      if (elDashboard) {
        elDashboard.innerHTML = "";
        new GrappleAuditLogDashboard({
          target: elDashboard,
        });
      }
    } catch (err) {
      console.warn("auditLogDashboard module unavailable:", err);
    }
  };

  onMount(() => {
    injectAuditLogCss();
    void mountGrappleAuditLogDashboard();
  });
</script>

<PageContainer>
  <div class="grid gap-3 w-full">
    <div class="uimodule audit-log-dark" bind:this={elDashboard} />
    <div class="uimodule">
      <GrappleAuditLogTable />
    </div>
  </div>
</PageContainer>
